import { type QueryHookOptions, useQuery } from '@apollo/client';

import { gql } from '@/generated';
import { useFilterConditions } from '@/contexts';
import { type IndexPageQuery, type IndexPageQueryVariables } from '@/generated/graphql';

const QUERY = gql(/* GraphQL */ `
  query IndexPage($filter: [FilterCond]) {
    healthcareIndicators(filter: $filter) {
      ...Index_SampleSizeFragment
      ...Index_AssetsUnderManagementFragment
      ...Index_FinancialReturnsFragment
      ...Index_AssetClassFragment
      ...Index_CountryIncomeGroupFragment
      ...Index_GeographicFocusFragment
      ...Index_RegionsAndCountriesFragment
      ...Index_StrategicGoalsFragment
      ...Index_StrategicDevelopmentGoalsFragment
      ...Index_HealthcareTypeFragment
      ...Index_StageOfBusinessFragment
      ...Index_SettingOfCareFragment
      ...Index_PresenceOfCertificationsFragment
      ...Index_CertificationsPresentFragment
      ...Index_TargetStakeholderFragment
      ...Index_DiseaseAddressedFragment
    }
  }
`);

export function useIndexData(
  options: QueryHookOptions<IndexPageQuery, IndexPageQueryVariables> = {}
) {
  const { benchmark } = useFilterConditions();
  const query = useQuery(QUERY, { variables: { filter: benchmark }, ...options });

  return {
    ...query,
    indicators: query.data?.healthcareIndicators,
  };
}
